/**
 * @module FE-CU21_IDカード／キー情報設定画面
 */
import Header from '../../../components/header/Header.vue';
import BreadCrumbList from '../../../components/breadCrumb/List.vue';
import Input from '../../../components/form/Input.vue';
import MobileFooter from '../../../components/footer/MobileFooter.vue';
import ListPanel from '../../../components/listPanel/ListPanel.vue';
import PcPageTitle from '../../../components/pcPageTitle/PcPageTitle.vue';
import ConfirmDialog from '../../../components/dialog/ConfirmDialog.vue';
import messageDialogVue from '../../../components/modal/messageDialog.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../../constants';
import { checkASCIIAndJISX0208 } from '../../../utile/validation';

const PAGE_ID = 'FE-CU21';

export default {
  name: 'IdCardKeyInfo',
  components: {
    Header,
    BreadCrumbList,
    Input,
    MobileFooter,
    ListPanel,
    PcPageTitle,
    ConfirmDialog,
    messageDialogVue,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU21IDカードキー情報設定画面.IDカードキー情報設定'), //"IDカード/キー情報設定",
      noSettingNotificationDialog: false,
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU21IDカードキー情報設定画面.C0001'),
      //"IDカード/キーのニックネームの変更、有効/無効の設定を行うことができます。",
      panelTitle: {
        place: ``,
        type: '$vuetify.FECU21IDカードキー情報設定画面.対象地区',
        typeIsBefore: false,
      },
      displayDistrictInfo: {
        displayDistrictFacilityName: '',
        usagePlan: 0,
        customerNumber: '',
        displayDistrictNickname: '',
        districtSplitNumber: '',
      },
      securityUnitExecutionResult: 0,
      commandExecutionResult: {
        app_cu2101: {
          IDCardKeyInfo: [],
        },
        app_cu2102: {
          requetResult: 0,
        },
      },
      initIDCardKeyInfo: [],
      isDisabled: true,
      cardId1: '',
      cardId2: '',
      cardId3: '',
      value: null,
      errors: {},
      readonly: false,
      picked1: '',
      picked2: '',
      picked3: '',
      checked1: false,
      checked2: false,
      checked3: false,
      displayAreaList: [],
      initCommandExecutionResult: {},
      rules: {
        cardKeyNickname: [
          (value) =>
            !!value ||
            vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU21IDカードキー情報設定画面.E0001'),
          (value) =>
            typeof value === 'undefined'
              ? true
              : checkASCIIAndJISX0208(value) ||
                vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU21IDカードキー情報設定画面.E0002'),
        ],
      },
      CONSTANTS: CONSTANTS,
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU21IDカードキー情報設定画面.IDカードキー情報設定'), //"IDカード/キー情報設定",
        hintText: vm.$vuetify.lang.t(
          '$vuetify.メッセージ一覧.FECU21IDカードキー情報設定画面.C0001'
        ),
        //"IDカード/キーのニックネームの変更、有効/無効の設定を行うことができます。",
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 初期表示(APP_CU2101)
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストのパラメータ
     * @param {*} method リクエストメソッド
     * @returns レスポンス
     */
    APP_CU2101: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(async (response /* eslint-disable-line */) => {
          apiData = this.$store.getters[`requestApi/${method}ApiInfo`];

          // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     displayDistrictInfo: {
          //       usagePlan: 0,
          //       customerNumber: "51-12345678",
          //       securityDestinationName: "警備先1",
          //       districtSplitNumber: "0001",
          //       districtSplitName: "地区名1",
          //       displayDistrictNickname: "自宅",
          //     },
          //     sendCustomerNumber: "0001",
          //     sendCommandKey: "0002",
          //   },
          // };

          this.panelTitle = {
            place: `- ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`,
            type: '$vuetify.FECU21IDカードキー情報設定画面.対象地区',
            typeIsBefore: true,
          };
          //`対象地区 - ${apiData.contentsInfo.displayDistrictInfo.displayDistrictNickname}`;
          const targetItem = apiData.contentsInfo.displayDistrictInfo;
          const labels = {
            usagePlan: '$vuetify.FECU21IDカードキー情報設定画面.対象地区詳細領域.利用プラン', // "利用プラン",
            customerNumber: '$vuetify.FECU21IDカードキー情報設定画面.対象地区詳細領域.お客様番号', //"お客様番号",
            securityDestinationName:
              '$vuetify.FECU21IDカードキー情報設定画面.対象地区詳細領域.警備先名', // "警備先名",
            districtSplitNumber:
              '$vuetify.FECU21IDカードキー情報設定画面.対象地区詳細領域.地区番号', //"地区番号",
            districtSplitName: '$vuetify.FECU21IDカードキー情報設定画面.対象地区詳細領域.地区名', // "地区名",
          };
          const targetKeys = [
            'usagePlan',
            'customerNumber',
            'securityDestinationName',
            'districtSplitNumber',
            'districtSplitName',
          ];
          const planTitles = {
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN]:
              '$vuetify.コード.利用プランID.オンライン監視プラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN]:
              '$vuetify.コード.利用プランID.依頼かけつけプラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE]:
              '$vuetify.コード.利用プランID.依頼かけつけプラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN]:
              '$vuetify.コード.利用プランID.セルフ監視プラン',
            [CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE]:
              '$vuetify.コード.利用プランID.セルフ監視プラン',
          };
          Object.keys(targetItem).map((key) => {
            if (targetKeys.includes(key)) {
              let text = targetItem[key];
              if (key === 'usagePlan') {
                text = planTitles[targetItem[key]];
              }
              if (key === 'securityDestinationName') {
                if (targetItem['customerNumber'] === '') {
                  return;
                }
              }
              if (key === 'districtSplitNumber') {
                if (targetItem['customerNumber'] === '') {
                  return;
                }
                if (targetItem[key] === '') {
                  return;
                }
                if (targetItem[key] === '    ') {
                  text = '$vuetify.FECU21IDカードキー情報設定画面.メイン地区';
                }
                if (key === 'districtSplitName') {
                  if (targetItem['customerNumber'] === '') {
                    return;
                  }
                }
              }
              if (key === 'districtSplitName') {
                if (targetItem['customerNumber'] === '') {
                  return;
                }
              }
              // if (key === "displayDistrictNickname") {
              //   if (targetItem["customerNumber"] === "") {
              //     return;
              //   }
              // }

              this.displayAreaList = [
                ...this.displayAreaList,
                {
                  title: labels[key],
                  text: text,
                  isVuetifyKey: text.includes('$'),
                },
              ];
            }
          });

          // APP_CO9915
          if (typeof apiData.contentsInfo !== 'undefined') {
            let params = {
              token: sessionStorage.getItem('token'),
              terminalInfo: localStorage.getItem('terminalInfo'),
              sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
              sendCommandKey: apiData.contentsInfo.sendCommandKey,
              apiId: 12,
              alarmType: 0,
              districtSplitNumber: '',
              securityAreaId: '',
            };
            apiData = await this.APP_CO9915(params);

            // サンプル 9915でエラーになるため
            // apiData = {
            //   contentsInfo: {
            //     securityUnitExecutionResult: 0,
            //     commandExecutionResult: {
            //       app_cu2101: {
            //         IDCardKeyInfo: [
            //           {
            //             cardKeyInfo: "ID123456789",
            //             cardKeyNickname: "山田 太郎のカード",
            //             isValid: true,
            //             cardKeyType: 1,
            //           },
            //           {
            //             cardKeyInfo: "ID223456789",
            //             cardKeyNickname: "山田 一郎のカード",
            //             isValid: true,
            //             cardKeyType: 1,
            //           },
            //           {
            //             cardKeyInfo: "ID323456789",
            //             cardKeyNickname: "山田 花子のカード",
            //             isValid: true,
            //             cardKeyType: 1,
            //           },
            //           {
            //             cardKeyInfo: "ID423456789",
            //             cardKeyNickname: "予備のカード",
            //             isValid: false,
            //             cardKeyType: 1,
            //           },
            //         ],
            //       },
            //     },
            //   },
            // };

            if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
              //#28295 警備ユニットから、9文字以上のカード名が来るので、画面としては、空白をtrimして9文字分表示
              if (
                apiData.contentsInfo.commandExecutionResult.app_cu2101 &&
                apiData.contentsInfo.commandExecutionResult.app_cu2101.IDCardKeyInfo
              ) {
                //チェックしてループ
                for (
                  var i = 0;
                  apiData.contentsInfo.commandExecutionResult.app_cu2101.IDCardKeyInfo.length > i;
                  i += 1
                ) {
                  //抽出
                  let trimCardNickname =
                    apiData.contentsInfo.commandExecutionResult.app_cu2101.IDCardKeyInfo[i]
                      .cardKeyNickname;
                  if (!trimCardNickname) {
                    trimCardNickname = '';
                  }
                  //前後の空白除去
                  trimCardNickname = trimCardNickname.trim();
                  //先頭から9文字抽出
                  if (trimCardNickname.length > 9) {
                    trimCardNickname = trimCardNickname.substring(0, 9);
                  }
                  //再代入
                  apiData.contentsInfo.commandExecutionResult.app_cu2101.IDCardKeyInfo[
                    i
                  ].cardKeyNickname = trimCardNickname;
                }
              }

              this.commandExecutionResult.app_cu2101 =
                apiData.contentsInfo.commandExecutionResult.app_cu2101;
              this.securityUnitExecutionResult = apiData.contentsInfo.securityUnitExecutionResult;
              // clone init object for comparison
              this.initIDCardKeyInfo = JSON.parse(
                JSON.stringify(apiData.contentsInfo.commandExecutionResult.app_cu2101.IDCardKeyInfo)
              );
            } else {
              await this.$_securityUnitExecutionResultDialog(
                apiData.contentsInfo.securityUnitExecutionResult
              );
            }
          }
        })
        .catch((error) => {
          if (error.message.includes('403')) {
            this.$router.replace({
              path: '/top',
            });
          } else {
            this.$_abnormality(error.response.status);
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });
      // console.log("APP_CU2101>>>", apiData);
      return apiData;
    },
    /**
     * APP_CU2101に対する警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     * @returns レスポンス
     */
    APP_CO9915: async function (params /* eslint-disable-line */) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
        })
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * APP_CU2102に対する警備ユニットコマンド実行結果確認(APP_CO9915)
     * @param {*} params リクエストのパラメータ
     */
    APP_CO9915_2102: async function (params /* eslint-disable-line */) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          if (
            apiData.contentsInfo.securityUnitExecutionResult == 0 &&
            apiData.contentsInfo.commandExecutionResult.app_cu2102.requestResult == 0
          ) {
            this.$informationDialog(
              '$vuetify.FECU21IDカードキー情報設定画面.設定が完了しました',
              false,
              true
            );
          } else {
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });
      return;
    },
    /**
     * APP_CU2102呼び出し処理
     */
    async callSaveMessageDialog() {
      await this.APP_CU2102();
    },
    /**
     * 登録確認ダイアログ表示処理
     */
    async openDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU21IDカードキー情報設定画面.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === true) {
        // OK
        this.isDisabled = true;
        this.callSaveMessageDialog();
      } else {
        // キャンセル
      }
    },
    /**
     * 画面遷移確認ダイアログ表示処理
     * @param {*} next RouteVueの画面遷移関数
     */
    async openNotificationDialog(next) {
      this.noSettingNotificationDialog = true;

      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU21IDカードキー情報設定画面.C0004',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );

      this.noSettingNotificationDialog = false;
      if (result) {
        next();
      } else {
        next(false);
      }
    },
    /**
     * IDカードキー情報更新(APP_CU2102)
     * @returns レスポンス
     */
    APP_CU2102: async function () {
      this.$_setLoading(true);

      let param = '/api/IDCardKeySetting/update';
      // let param = "post";
      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        IDCardKeyInfo: this.commandExecutionResult.app_cu2101.IDCardKeyInfo,
      };

      let method = 'post';
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // apiData = {
            //   contentsInfo: {
            //     sendCustomerNumber: "send-customer-number",
            //     sendCommandKey: "send-command-key",
            //   },
            // };

            if (typeof apiData.contentsInfo !== 'undefined') {
              let params = {
                token: sessionStorage.getItem('token'),
                terminalInfo: localStorage.getItem('terminalInfo')
                  ? localStorage.getItem('terminalInfo')
                  : '',
                sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
                sendCommandKey: apiData.contentsInfo.sendCommandKey,
                apiId: 13,
                alarmType: 0,
                districtSplitNumber: this.displayDistrictInfo.districtSplitNumber,
                securityAreaId: '',
              };
              this.APP_CO9915_2102(params);
            }
          },
          (error) => {
            if (error.message.includes('400')) {
              this.$errorDialog('$vuetify.メッセージ一覧.FECU21IDカードキー情報設定画面.E0004');
            } else {
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * バリデーションチェック処理
     */
    checkValid: function () {
      // this.isDisabled = false;
      for (let idx = 0; idx < this.commandExecutionResult.app_cu2101.IDCardKeyInfo.length; idx++) {
        if (this.commandExecutionResult.app_cu2101.IDCardKeyInfo[idx].cardKeyNickname !== '') {
          if (
            this.commandExecutionResult.app_cu2101.IDCardKeyInfo[idx].isValid ===
              this.initIDCardKeyInfo[idx].isValid &&
            this.commandExecutionResult.app_cu2101.IDCardKeyInfo[idx].cardKeyNickname ===
              this.initIDCardKeyInfo[idx].cardKeyNickname
          ) {
            this.isDisabled = true;
          } else {
            this.isDisabled = false;
            break;
          }
        } else {
          this.isDisabled = true;
          break;
        }
      }
    },
    /**
     * 横幅変更処理
     * @param {*} width 横幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
    /**
     * 戻る処理
     */
    back() {
      this.$store.commit('setBackButtonFlag', { backButtonFlag: true });
      this.$router.back();
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    //以降は、ローディングマークを出して警備ユニットとの通信なので、ここで画面表示
    this.isShowPage = true;

    let param = '/api/IDCardKeySetting/init';

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
    };

    let method = 'post';
    await this.APP_CU2101(param, queries, method);
  },
  beforeRouteLeave(to, from, next) {
    // 有効無効の変更時、設定補を保存せずに画面遷移しようとした場合の確認ダイアログ
    if (this.isDisabled === false && this.$store.getters['isLoggedIn']) {
      if (this.noSettingNotificationDialog === true) {
        this.noSettingNotificationDialog === false;
        next();
      } else {
        this.openNotificationDialog(next);
      }
    } else {
      // this.$router.back();
      next();
    }
  },
};
